module.exports = __webpack_public_path__ + "img/moment-logo.3b61341b.svg";